import s from './index.module.scss';

export const MoneyFieldPlaceholder = ({ label, description, placeholder }) => {
  return (
    <div className={s.wrapper}>
      {label && <div className={s.label}>{label}</div>}
      <div className={s.placeholder}>{placeholder}</div>
      <div className={s.description}>{description}</div>
    </div>
  );
};
